export default __webpack_public_path__ + "static/media/kerala.bc28ae09.png";